module.exports = __webpack_public_path__ + "static/img/UNIFI_LOGO.d00502a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/UNIFI_LOGO.png
// module id = aq7t
// module chunks = 41